var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { cloneDeep, debounce } from 'lodash';
import { Project } from '@/models/Project';
let ProjectSelect = class ProjectSelect extends Vue {
    constructor() {
        super(...arguments);
        this.searchDebounce = this.handleProjectSearch();
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.defaultFilters = {};
        this.projects = [];
        this.selectedProjects = [];
        this.searchInput = '';
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        if (this.value) {
            this.itemsChanged(this.value);
        }
        this.defaultFilters = { ...this.filters, ...this.defaultFilters };
        this.initialize();
    }
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    searchInputChanged(val) {
        if (!this.searchInput) {
            this.getProjects();
        }
    }
    async initialize() {
        await this.getProjects();
    }
    // #endregion
    // #region Class methods
    onChange(value) {
        // console.log('projects', value);
        this.$emit('input', value);
        this.$emit('change');
    }
    handleProjectSearch() {
        return debounce(() => {
            this.getProjects();
        }, 400);
    }
    // #endregion
    // #region Async methods
    async getProjects() {
        try {
            this.projects = await new Project()
                .filter('search', this.searchInput)
                .filter(this.defaultFilters)
                .limit(500)
                .all();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    itemsChanged(value) {
        // clear items
        if (!value) {
            this.selectedProjects = [];
        }
        else {
            this.selectedProjects = cloneDeep(value);
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], ProjectSelect.prototype, "value", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], ProjectSelect.prototype, "placeholder", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], ProjectSelect.prototype, "filters", void 0);
__decorate([
    Watch('searchInput'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProjectSelect.prototype, "searchInputChanged", null);
__decorate([
    Watch('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ProjectSelect.prototype, "itemsChanged", null);
ProjectSelect = __decorate([
    Component({})
], ProjectSelect);
export default ProjectSelect;
